import React from 'react';
import { connect } from 'react-redux';
import { Table } from 'semantic-ui-react';
import QueryFilterContainer, {
  mapStateToProps,
} from '../components/QueryFilterContainer';
import QueryFilterValuesCell from './QueryFilterValuesCell';
import { cohortFilterWidths } from '../constants';
import QueryFilterValuesEditor from './QueryFilterValuesEditor';

const QueryFilterValuesTableCell = ({
  code,
  category,
  hasValues,
  dictionary,
  clauseUUID,
  filterUUID,
  isEditing,
  queryUUID,
  exists,
  canRead,
  canEdit,
}) => (
  <>
    {!hasValues && (<Table.Cell />)}
    {hasValues && !isEditing && (
      <QueryFilterValuesCell
        category={category}
        code={code}
        queryUUID={queryUUID}
        clauseUUID={clauseUUID}
        filterUUID={filterUUID}
        dictionaryCode={dictionary.code}
        width={cohortFilterWidths.VALUES}
      />
    )}
    {hasValues && isEditing && (
    <QueryFilterContainer
      exists={exists}
      canRead={canRead}
      canEdit={canEdit}
      queryUUID={queryUUID}
      width={cohortFilterWidths.VALUES}
    >
      <QueryFilterValuesEditor
        category={category}
        code={code}
        queryUUID={queryUUID}
        clauseUUID={clauseUUID}
        filterUUID={filterUUID}
        dictionaryCode={dictionary.code}
      />
    </QueryFilterContainer>
    )}
  </>
);

export default connect(mapStateToProps)(QueryFilterValuesTableCell);
